import { render, staticRenderFns } from "./HotlineDialog.vue?vue&type=template&id=3a936a18&scoped=true&"
var script = {}
import style0 from "./HotlineDialog.vue?vue&type=style&index=0&id=3a936a18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a936a18",
  null
  
)

export default component.exports